module.exports = __webpack_public_path__ + "img/marketing.6854a946.png";